/**
 * Esquema de cores dos marcadores de pedido no mapa da Roteirização.
 * - vermelho: pedido ainda NÃO alocado (sem entregador);
 * - preto: pedido já associado a um entregador;
 * - verde: destaque do pedido selecionado.
 */
export const COR_NAO_ALOCADO = "#e53935"
export const COR_ALOCADO = "#000000"
export const COR_SELECIONADO = "#2e7d32"
